import { createReducer, on } from '@ngrx/store';

import { IDataRespAuthUserPhone, IUserApp } from '../../shared/models/Tenderos.interface';
import {
    authUserPhone,
    cancelAccount,
    clearDataUser,
    clearDataUserSuccess,
    errroAuthUserPhone,
    errroCancelAccount,
    errroGetConfig,
    errroValidatedJwtBOUser,
    errroValidatedJwtWaUser,
    getConfig,
    resetAuthUserPhone,
    resetCancelAccount,
    resetGetConfig,
    resetValidatedJwtBOUser,
    resetValidatedJwtWaUser,
    setDateBD,
    setEjecucion,
    setUserInfoApp,
    successAuthUserPhone,
    successCancelAccount,
    successGetConfig,
    successValidatedJwtBOUser,
    successValidatedJwtWaUser,
    validatedJwtBOUser,
    validatedJwtWaUser,
} from '../actions';
import { MENUHEADER } from './../../shared/models/Constants';


export interface IUserDataState extends IUserApp {
    DateBD: string;
}


export const UserDataInit: IUserDataState = {
    Responsable: '',
    DateBD: '',
    ID_Bodega: 0,
    NUD: 0,
    ID_Programa: 0,
    Menu: false,
    MenuMas: [],
    MenuHeader: MENUHEADER,
    Ejecucion: {
        FechasEjecucion: [],
        ID_Tendero: 0,
    }
};

const _userDataReducer = createReducer(UserDataInit,
    on(setUserInfoApp, (state, data) => ({ ...state, ...data })),
    on(setDateBD, (state, { DateBD }) => ({ ...state, DateBD })),
    on(setEjecucion, (state, Ejecucion) => ({ ...state, Ejecucion })),
    on(clearDataUser, state => ({ ...state, ...UserDataInit })),
    on(clearDataUserSuccess, state => ({ ...state, ...UserDataInit })),
);

export function UserDataReducer(state: any, action: any) {
    return _userDataReducer(state, action);
}

/**
 * * Cancelacion de cuenta
 */
export interface CancelAccountState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: string;
}

export const CancelAccountInit: CancelAccountState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: '',
};

const _cancelAccountReducer = createReducer(
    CancelAccountInit,
    on(cancelAccount, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successCancelAccount, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errroCancelAccount, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(resetCancelAccount, state => ({ ...state, ...CancelAccountInit }))
);

export function CancelAccountReducer(state: any, action: any) {
    return _cancelAccountReducer(state, action);
}

/**
 * * Validated Jwt Wa User
 */
export interface ValidJwtWaState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    Activo: boolean;
}

export const ValidJwtWaInit: ValidJwtWaState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    Activo: true,
};

const _validJwtWaReducer = createReducer(
    ValidJwtWaInit,
    on(validatedJwtWaUser, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successValidatedJwtWaUser, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            Activo: data.Activo,
        }
    )),
    on(errroValidatedJwtWaUser, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(resetValidatedJwtWaUser, state => ({ ...state, ...ValidJwtWaInit }))
);

export function ValidJwtWaReducer(state: any, action: any) {
    return _validJwtWaReducer(state, action);
}

/**
 * * Validated Jwt BO User
 */

const _validJwtBOReducer = createReducer(
    ValidJwtWaInit,
    on(validatedJwtBOUser, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successValidatedJwtBOUser, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            Activo: data.valid === 1,
        }
    )),
    on(errroValidatedJwtBOUser, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(resetValidatedJwtBOUser, state => ({ ...state, ...ValidJwtWaInit }))
);

export function ValidJwtBOReducer(state: any, action: any) {
    return _validJwtBOReducer(state, action);
}


/**
 * * Genera un nuevo token
 */
export interface AuthUserPhoneState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: IDataRespAuthUserPhone;
}

export const AuthUserPhoneInit: AuthUserPhoneState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {} as IDataRespAuthUserPhone,
};

const _authUserPhoneReducer = createReducer(
    AuthUserPhoneInit,
    on(authUserPhone, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successAuthUserPhone, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errroAuthUserPhone, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(resetAuthUserPhone, state => ({ ...state, ...AuthUserPhoneInit }))
);

export function AuthUserPhoneReducer(state: any, action: any) {
    return _authUserPhoneReducer(state, action);
}

/**
 * * Obtiene variable de configuracion
 */
export interface IConfigDataState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    LlaveConfiguracion: string;
    [key: string]: any;
};
export const ConfigDataInit: IConfigDataState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    LlaveConfiguracion: '',
};

const _configDataReducer = createReducer(ConfigDataInit,
    on(getConfig, (state, { LlaveConfiguracion }) => ({
        ...state,
        loading: true,
        success: false,
        failed: false,
        LlaveConfiguracion,
    })),
    on(successGetConfig, (state, { data }) => ({
        ...state,
        loading: false,
        success: true,
        [state.LlaveConfiguracion]: data[0].configuracion,
    })),
    on(errroGetConfig, (state, { payload }) => ({
        ...state,
        loading: false,
        failed: true,
        error: payload,
    })),
    on(resetGetConfig, state => ({ ...state, ...ConfigDataInit })),
);

export function ConfigDataReducer(state: any, action: any) {
    return _configDataReducer(state, action);
}

